import Cover from './Cover';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { madadAgentBannerItemSelector } from 'store/state/domainData/selectors';

const mapStateToProps = (state: State) => ({
  agentBanner: madadAgentBannerItemSelector(state),
});

export default connect(mapStateToProps)(Cover);
